import { Link } from 'react-router';
import { Button } from '../buttons/Button';
import { DimensionFeedback } from './DimensionFeedback';
import { PlanHistory } from './PlanHistory';
import { PlanRadarChart } from './PlanRadarChart';
import { DIMENSIONS, PlanHistoryEntry, PlanResponse } from '../../lib/plan/types';

interface PlanResultsProps {
    plan: PlanResponse;
    history: PlanHistoryEntry[];
    historyError?: boolean;
    onRetryHistory?: () => void;
}

export function PlanResults({
    plan,
    history,
    historyError = false,
    onRetryHistory,
}: PlanResultsProps) {
    const { dimension_scores, primary_dimension } = plan;
    const orderedDimensions = [
        primary_dimension,
        ...DIMENSIONS.filter((dim) => dim !== primary_dimension),
    ];
    const previous = history.length > 1 ? history[1] : undefined;

    return (
        <div>
            <div className="mb-6 text-center">
                <h4>Profil vaší třídy</h4>
                <p className="text-sm text-ink-700">
                    Silné stránky i místa, kde třída potřebuje podporu
                </p>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-sm">
                <div className="flex flex-wrap items-center gap-8">
                    {/* Graf drží svou šířku (viewBox 340×205) — bez shrink-0 by ho
                        delší texty vedle stlačily, protože si bere jen zbytek řádku. */}
                    <div className="mx-auto shrink-0">
                        <PlanRadarChart
                            scores={dimension_scores}
                            primary={primary_dimension}
                            previousScores={previous?.dimension_scores}
                        />
                    </div>
                    <div className="min-w-[280px] flex-1 space-y-3">
                        {orderedDimensions.map((dimension) => (
                            <DimensionFeedback
                                key={dimension}
                                dimension={dimension}
                                score={dimension_scores[dimension]}
                                previousScore={
                                    previous?.dimension_scores[dimension]
                                }
                                isPrimary={dimension === primary_dimension}
                            />
                        ))}
                    </div>
                </div>

                <div className="mt-8 flex justify-center">
                    <Link to="/plan-na-miru" className="w-full sm:w-auto">
                        <Button
                            color="product"
                            className="w-full px-10 py-4 text-base shadow-sm sm:w-auto"
                        >
                            Zobrazit plán
                        </Button>
                    </Link>
                </div>
            </div>

            <PlanHistory
                history={history}
                error={historyError}
                onRetry={onRetryHistory}
            />
        </div>
    );
}
